export const MIN_BABY_LOAN_AMOUNT = 3_000_000;
export const MAX_BABY_LOAN_AMOUNT = 11_000_000;

export const MIN_MORTGAGE_AMOUNT = 3_000_000;
export const MAX_MORTGAGE_AMOUNT = 80_000_000;

export const MIN_PERSONAL_LOAN_AMOUNT = 500_000;
export const MAX_PERSONAL_LOAN_AMOUNT = 10_000_000;

export const MAX_AGE = 64;
